module.exports = __webpack_public_path__ + "img/组 3.353241a0.png";